import React from 'react';
import LRCViewer from '../../../units/LRCViewer';

export const LRCRenderer = ({
    unit,
    completedUnits = {},
    onComplete
}) => {
    return (
        <div className="unit-content">
            <LRCViewer
                unitData={unit}
                onComplete={(unitId, status) => {
                    if (onComplete) onComplete(unitId, status);
                }}
                userProgress={completedUnits[unit.id]}
            />
        </div>
    );
};